import React, { useRef } from 'react'
import {
  IconButton,
  Typography,
  Chip,
  Stack
} from '@mui/material'
import { styled } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'

const AttachWrap = styled('div')({
  padding: '10px 0',
  '&.disabled': {
    opacity: 0.2
  },
})
const Input = styled('input')({
  display: 'none'
})
const InputBox = styled(Stack)({
  border: '1px solid #ccc',
  minHeight: 34,
  padding: '5px 10px',
  cursor: 'pointer',
  borderRadius: 3,
  '&:hover': {
    borderColor: '#000'
  }
})
const InputBoxCover = styled('div')({
  width: '100%',
  wordBreak: 'break-all'
})
const InputChip = styled(Chip)({
  margin: '5px 0'
})

const AttachFile = ({
  title,
  name,
  path,
  type,
  disabled,
  addFile,
  deleteFile
}) => {
  const uploadEl = useRef(null)

  const uploadFile = () => {
    uploadEl.current.click()
  }

  const handleChangeFile = (e) => {
    let files = e.target ? e.target.files : e
    if (files.length) {
      addFile(type, files[0])
    }
  }

  const handleFileDelete = (e) => {
    e.stopPropagation()
    deleteFile(type)
  }

  const handleDownload = (e) => {
    e.stopPropagation()
  }

  return (
    <AttachWrap className={disabled && 'disabled'}>
      <Typography variant="subtitle2" gutterBottom component="div" onClick={uploadFile}>
        <Input
          disabled={disabled}
          type="file"
          accept="application/pdf"
          ref={uploadEl}
          onChange={handleChangeFile}
        />
        <IconButton color="primary" aria-label="upload picture" component="span">
          <AddIcon />
        </IconButton>
        {title}
      </Typography>
      <InputBox direction="row" spacing={1} onClick={uploadFile}>
        <InputBoxCover>
          {
            name &&
            <InputChip
              label={name}
              onClick={(e) => handleDownload(e)}
              onDelete={(e) => handleFileDelete(e)}
            />
          }
        </InputBoxCover>
      </InputBox>
    </AttachWrap>
  )
}

export default AttachFile